import { Button, Group, type GroupProps, Pill, Text } from "@mantine/core";
import classNames from "classnames";
import "./FilterPillsGroup.scss";

interface FilterPill {
  key: string;
  label: string;
  columnId: string;
  /** Filter value to set when removing this pill – `undefined` clears the whole column filter */
  nextFilterValue?: unknown;
}

interface FilterPillsGroupProps extends GroupProps {
  pills: Array<FilterPill>;
  onRemove: (columnId: string, nextFilterValue?: unknown) => void;
  onRemoveAll: () => void;
}

function FilterPillsGroup({
  pills,
  onRemove,
  onRemoveAll,
  ...groupProps
}: FilterPillsGroupProps) {
  return (
    <Group
      {...groupProps}
      className={classNames("FilterPillsGroup", groupProps.className)}
      gap="md"
      pb="md"
      wrap="nowrap"
    >
      <Group gap="xs">
        {pills.map((chip) => (
          <Pill
            key={chip.key}
            removeButtonProps={{
              "aria-hidden": false,
              "aria-label": `${chip.label} entfernen`
            }}
            withRemoveButton
            onRemove={() => onRemove(chip.columnId, chip.nextFilterValue)}
          >
            {chip.label}
          </Pill>
        ))}
      </Group>
      <Text c="dimmed" className="active-filters-amount" fz="sm">
        {pills.length} Filter gesetzt
      </Text>
      <Button
        className="remove-all-button"
        p={0}
        variant="transparent"
        onClick={onRemoveAll}
      >
        Alle Filter entfernen
      </Button>
    </Group>
  );
}

export { FilterPillsGroup, FilterPill };
